import React, { FC } from 'react';
import { AnalyticsPagesTimeSpentProps } from './AnalyticsPagesTimeSpentProps';
import { BarChartPro } from '@mui/x-charts-pro/BarChartPro';
import { formatToTime } from './utils';
import AnalyticsLoader from '../AnalyticsLoader';

const AnalyticsPagesTimeSpent: FC<AnalyticsPagesTimeSpentProps> = ({
  data,
  loading,
}) => {
  return (
    <AnalyticsLoader loading={loading}>
      <BarChartPro
        dataset={data}
        xAxis={[
          {
            scaleType: 'band',
            dataKey: 'location',
            tickLabelStyle: { angle: -45 },
          },
        ]}
        yAxis={[
          {
            valueFormatter: (value) => formatToTime(value),
          },
        ]}
        series={[
          {
            dataKey: 'number',
            valueFormatter: (value) => formatToTime(value),
            label: 'Avg Time Spent',
          },
        ]}
        slots={{
          noDataOverlay: () => null,
        }}
      />
    </AnalyticsLoader>
  );
};

export default AnalyticsPagesTimeSpent;
